<template lang="pug">
  v-container(fluid)
    h1 Our Calendar
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped></style>
